module.exports = __webpack_public_path__ + "static/img/1.d000f62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/zh/1.png
// module id = CB88
// module chunks = 0